import axios from "axios";

export const state = {
    antenatalpatients: [],
};

export const getters = {
    antenatalpatients: state => state.antenatalpatients,
};

export const mutations = {
    setPatients(state, newValue) {
        state.antenatalpatients = newValue
    },
};

export const actions = {
    fetchAntenatalPatients({ commit }) {
        axios.get('/antenatalpatients').then(res => {
            commit('setPatients', res.data.visits)
        })
    },
    filterAntenatalPatients({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterantenatalpatients";
        axios.post(url, formData).then((response) => {
            commit('setPatients', response.data.visits)
        })
    },
};
